/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FleetAuthenticateLogoutType } from './FleetAuthenticateLogoutType';
import {
    FleetAuthenticateLogoutTypeFromJSON,
    FleetAuthenticateLogoutTypeFromJSONTyped,
    FleetAuthenticateLogoutTypeToJSON,
    FleetAuthenticateLogoutTypeToJSONTyped,
} from './FleetAuthenticateLogoutType';
import type { FleetAuthenticateType } from './FleetAuthenticateType';
import {
    FleetAuthenticateTypeFromJSON,
    FleetAuthenticateTypeFromJSONTyped,
    FleetAuthenticateTypeToJSON,
    FleetAuthenticateTypeToJSONTyped,
} from './FleetAuthenticateType';
import type { FleetAuthenticateConnectionStatus } from './FleetAuthenticateConnectionStatus';
import {
    FleetAuthenticateConnectionStatusFromJSON,
    FleetAuthenticateConnectionStatusFromJSONTyped,
    FleetAuthenticateConnectionStatusToJSON,
    FleetAuthenticateConnectionStatusToJSONTyped,
} from './FleetAuthenticateConnectionStatus';

/**
 * 
 * @export
 * @interface FleetAuthenticateEvent
 */
export interface FleetAuthenticateEvent {
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEvent
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof FleetAuthenticateEvent
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FleetAuthenticateEvent
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEvent
     */
    periodId: string;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEvent
     */
    vehicleId: string;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEvent
     */
    userId: string;
    /**
     * 
     * @type {FleetAuthenticateType}
     * @memberof FleetAuthenticateEvent
     */
    authenticateType: FleetAuthenticateType;
    /**
     * 
     * @type {FleetAuthenticateConnectionStatus}
     * @memberof FleetAuthenticateEvent
     */
    connectionStatus?: FleetAuthenticateConnectionStatus | null;
    /**
     * 
     * @type {FleetAuthenticateLogoutType}
     * @memberof FleetAuthenticateEvent
     */
    logoutType?: FleetAuthenticateLogoutType | null;
    /**
     * Sequential ID used to ensure that the background workers only process a row once.
     * @type {number}
     * @memberof FleetAuthenticateEvent
     */
    sequentialId: number;
}



/**
 * Check if a given object implements the FleetAuthenticateEvent interface.
 */
export function instanceOfFleetAuthenticateEvent(value: object): value is FleetAuthenticateEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('periodId' in value) || value['periodId'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('authenticateType' in value) || value['authenticateType'] === undefined) return false;
    if (!('sequentialId' in value) || value['sequentialId'] === undefined) return false;
    return true;
}

export function FleetAuthenticateEventFromJSON(json: any): FleetAuthenticateEvent {
    return FleetAuthenticateEventFromJSONTyped(json, false);
}

export function FleetAuthenticateEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetAuthenticateEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'time': (new Date(json['time'])),
        'periodId': json['periodId'],
        'vehicleId': json['vehicleId'],
        'userId': json['userId'],
        'authenticateType': FleetAuthenticateTypeFromJSON(json['authenticateType']),
        'connectionStatus': json['connectionStatus'] == null ? undefined : FleetAuthenticateConnectionStatusFromJSON(json['connectionStatus']),
        'logoutType': json['logoutType'] == null ? undefined : FleetAuthenticateLogoutTypeFromJSON(json['logoutType']),
        'sequentialId': json['sequentialId'],
    };
}

export function FleetAuthenticateEventToJSON(json: any): FleetAuthenticateEvent {
    return FleetAuthenticateEventToJSONTyped(json, false);
}

export function FleetAuthenticateEventToJSONTyped(value?: FleetAuthenticateEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'time': value['time'].toISOString(),
        'periodId': value['periodId'],
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'authenticateType': FleetAuthenticateTypeToJSON(value['authenticateType']),
        'connectionStatus': FleetAuthenticateConnectionStatusToJSON(value['connectionStatus']),
        'logoutType': FleetAuthenticateLogoutTypeToJSON(value['logoutType']),
        'sequentialId': value['sequentialId'],
    };
}

